// mutations
// user namespace
export const SET_CURRENT_ENVIRONMENT = 'SET_CURRENT_ENVIRONMENT'
export const SET_CURRENT_SUBSIDIARY = 'SET_CURRENT_SUBSIDIARY'
export const SET_TEMP_ENVIRONMENT = 'SET_TEMP_ENVIRONMENT'

// reports namespace
export const GET_FILTERS_PENDING = 'GET_FILTERS_PENDING'
export const GET_FILTERS_ERROR = 'GET_FILTERS_ERROR'
export const GET_FILTERS_SUCCESS = 'GET_FILTERS_SUCCESS'
export const SET_APPLIED_DATE_RANGE = 'SET_APPLIED_DATE_RANGE'
export const CLEAR_APPLIED_DATE_RANGE = 'CLEAR_APPLIED_DATE_RANGE'
export const TOGGLE_FILTER_CATEGORY = 'TOGGLE_FILTER_CATEGORY'
export const CLEAR_OPEN_FILTER_CATEGORIES = 'CLEAR_OPEN_FILTER_CATEGORIES'
export const UPDATE_CATEGORY_FILTERS = 'UPDATE_CATEGORY_FILTERS'
export const CLEAR_CATEGORY_FILTERS = 'CLEAR_CATEGORY_FILTERS'
export const CLEAR_ALL_CATEGORY_FILTERS = 'CLEAR_ALL_CATEGORY_FILTERS'
/*
 * when mutations are stored under a namespace, Vuex automatically adds the namespace name to the
 * `mutation.type` we are using to filter mutations that are persisted. that is why we are
 * preprending the namespace to mutations below
 */
export const MUTATIONS_TO_PERSIST = [
  `user/${SET_CURRENT_ENVIRONMENT}`,
  `user/${SET_CURRENT_SUBSIDIARY}`
]
